import script from "./right-top.vue?vue&type=script&setup=true&lang=ts"
export * from "./right-top.vue?vue&type=script&setup=true&lang=ts"

import "./right-top.vue?vue&type=style&index=0&id=0d828799&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d828799"]])

export default __exports__